
import { mapActions } from "vuex";
import Form from "./Form.vue";
import { mapGetters } from "vuex";

export default {
  name: "app-financeiro-update",
  data() {
    return {
      financeiro: {},
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getfinanceiro(id) {
      const { data } = await this.$http.post("/financeiro/find", {
        id: id,
      });

      return data;
    },
    async getInit() {
      try {
        const id = this.$route.params.id;

        this.setLoading(true);

        const financeiro = await this.getfinanceiro(id);

        this.setLoading(false);

        if (!financeiro.id || financeiro == null) {
          this.$router.push({ name: "financeiroLista" });
          return this.$toast.error("Movimento não encontrado!");
        }

        this.financeiro = await financeiro;
      } catch {
        return;
      }
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }

    this.getInit();
  },
};
